import React from "react";

/**
 * Official cpenz brand icon. Renders the supplied asset exactly as-is.
 * Do NOT redraw, reinterpret or replace. Only transforms (float/scale/opacity) are applied.
 */
export function CPENZIcon({ size = 40, className = "", float = false, glow = false, style = {} }) {
  return (
    <span
      className={`relative inline-flex items-center justify-center rounded-[28%] bg-[#0b0f1a] ${float ? "animate-float" : ""} ${className}`}
      style={{ width: size, height: size, ...style }}
      data-testid="cpenz-icon"
    >
      {glow && (
        <span
          className="absolute inset-0 rounded-full animate-shimmer"
          style={{
            background: "radial-gradient(circle, rgba(124,58,237,0.35) 0%, rgba(59,130,246,0.18) 45%, transparent 70%)",
            filter: "blur(18px)",
            transform: "scale(1.6)",
          }}
        />
      )}
      <img
        src="/cpenz-icon-white.png"
        alt="cpenz"
        draggable={false}
        style={{ width: "100%", height: "100%", objectFit: "contain", position: "relative" }}
      />
    </span>
  );
}

export function CPENZWordmark({ className = "", iconSize = 26 }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <CPENZIcon size={iconSize} />
      <span className="font-bold lowercase tracking-[0.14em] text-[#0b0f1a]" style={{ fontSize: iconSize * 0.72 }}>
        cpenz
      </span>
    </span>
  );
}

export default CPENZIcon;
